/**
 * The settings of the Organisation this window administers: its name, its
 * adapter and its on/off switch
 * (docs/adr/39-two-admin-clients-the-elaso-instance-admin-client-and-the-organisation-admin-client.md).
 * A thin wrapper: the page is `components/organization/settings/organization-settings.tsx`.
 */
import { createFileRoute } from "@tanstack/react-router";
import { useAdministeredOrganization } from "@/components/organization/administered-organization";
import { OrganizationSettings } from "@/components/organization/settings/organization-settings";

export const Route = createFileRoute("/organization/$organizationId/settings")({
	component: OrganizationSettingsPage,
});

function OrganizationSettingsPage() {
	const organization = useAdministeredOrganization();
	return (
		<div className="flex flex-col items-center gap-4 p-4 md:p-8">
			<OrganizationSettings
				key={organization.organizationId}
				organization={organization}
			/>
		</div>
	);
}
